import { create } from "zustand";

/**
 * UX3010-13: whether a card has unsaved input. The organization switcher in the header asks before it changes the
 * working organization, so a contract or a document of one organization is never carried into another one.
 */
interface UnsavedState {
  dirty: boolean;
  setDirty: (dirty: boolean) => void;
}

export const useUnsaved = create<UnsavedState>()((set) => ({
  dirty: false,
  setDirty: (dirty) => set({ dirty }),
}));
